import { render, staticRenderFns } from "./DetailNavbar.vue?vue&type=template&id=141f47ad&scoped=true"
import script from "./DetailNavbar.vue?vue&type=script&lang=js"
export * from "./DetailNavbar.vue?vue&type=script&lang=js"
import style0 from "./DetailNavbar.vue?vue&type=style&index=0&id=141f47ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141f47ad",
  null
  
)

export default component.exports